
require('./bootstrap');



import videoJs from 'video.js';
window.videojs = videoJs;

// require('videojs-hls-quality-selector');
// import 'videojs-contrib-quality-levels';


// require('videojs-seek-buttons');
require('videojs-resolution-switcher');


// require("videojs-vtt-thumbnails");


$(document).ready(function () {

    videojs.addLanguage('fa', {
        "Play": "پخش",
        "Pause": "Pausa",
        "Auto": "خودکار",
        "Quality": "کیفیت پخش",
        "Current Time": "Tiempo reproducido",
        "Duration": "Duración total",
        "Remaining Time": "Tiempo restante",
        "Stream Type": "Tipo de secuencia",
        "LIVE": "زنده",
        "Reset": "تنظیم مجدد",
        "Text": "متن",
        "Background": "زمینه",
        "Window": "کادر",
        "Done": "اعمال تغییرات",
        "Font Size": "اندازه فونت",
        "Loaded": "Cargado",
        "Progress": "Progreso",
        "Fullscreen": "Pantalla completa",
        "Non-Fullscreen": "Pantalla no completa",
        "Mute": "Silenciar",
        "Unmute": "No silenciado",
        "Playback Rate": "Velocidad de reproducción",
        "subtitles settings": "تنظیمات",
        "Subtitles": "زیرنویس",
        "subtitles off": "خاموش",
        "Captions": "Subtítulos especiales",
        "captions off": "Subtítulos especiales desactivados",
        "Chapters": "Capítulos",
        "Close Modal Dialog": "Cerca de diálogo modal",
        "You aborted the video playback": "Ha interrumpido la reproducción del vídeo.",
        "A network error caused the video download to fail part-way.": "Un error de red ha interrumpido la descarga del vídeo.",
        "The video could not be loaded, either because the server or network failed or because the format is not supported.": "No se ha podido cargar el vídeo debido a un fallo de red o del servidor o porque el formato es incompatible.",
        "The video playback was aborted due to a corruption problem or because the video used features your browser did not support.": "La reproducción de vídeo se ha interrumpido por un problema de corrupción de datos o porque el vídeo precisa funciones que su navegador no ofrece.",
        "No compatible source was found for this video.": "No se ha encontrado ninguna fuente compatible con este vídeo."
    });


});
